import React, { useState } from 'react';

import { WpButton } from '../../button';
import { WpDrawerV2, WpDrawerV2Body } from '../index';

const DrawerDocs = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <WpButton onClick={toggleIsOpen}>open</WpButton>
      <WpDrawerV2 isOpen={isOpen} toggleIsOpen={toggleIsOpen}>
        <WpDrawerV2Body>Hello from the Drawer</WpDrawerV2Body>
      </WpDrawerV2>
    </div>
  );
};

export default DrawerDocs;
